import type { Type } from '@/domains/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type {
  MerchandizingBannersState,
  MerchandizingBannerState,
} from '../MerchandizingBanners.model';

export const selectMerchandizingBannersState = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): MerchandizingBannersState | undefined =>
  state.productDiscovery?.merchandizingBanners;

export const selectMerchandizingBanners =
  (type: Type) =>
  (
    state: Partial<SpartacuxProductDiscoveryDomainState>,
  ): MerchandizingBannerState | undefined =>
    selectMerchandizingBannersState(state)?.[type];
